import ApplicationSerializer from './application';

export default class UserDocumentAttachmentSerializer extends ApplicationSerializer {
  attrs = {
    createdAt: {
      serialize: false,
    },
    updatedAt: {
      serialize: false,
    },
    fileUrl: {
      serialize: false,
    },
  };
}
